'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AccountId$() {
  this.c3Q = null;
  this.c3R = false;
  this.c3O = null;
  this.c3P = false;
}
export { $c_Lpresto_types$AccountId$ as $c_Lpresto_types$AccountId$ };
$p = $c_Lpresto_types$AccountId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AccountId$;
/** @constructor */
function $h_Lpresto_types$AccountId$() {
}
export { $h_Lpresto_types$AccountId$ as $h_Lpresto_types$AccountId$ };
$h_Lpresto_types$AccountId$.prototype = $p;
$p.a2B = (function() {
  if ((!this.c3R)) {
    this.c3Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.c3R = true;
  }
  return this.c3Q;
});
$p.bl = (function() {
  if ((!this.c3P)) {
    this.c3O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c3P = true;
  }
  return this.c3O;
});
var $d_Lpresto_types$AccountId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AccountId$, "presto.types$AccountId$", ({
  Yo: 1,
  D: 1
}));
export { $d_Lpresto_types$AccountId$ as $d_Lpresto_types$AccountId$ };
var $n_Lpresto_types$AccountId$;
function $m_Lpresto_types$AccountId$() {
  if ((!$n_Lpresto_types$AccountId$)) {
    $n_Lpresto_types$AccountId$ = new $c_Lpresto_types$AccountId$();
  }
  return $n_Lpresto_types$AccountId$;
}
export { $m_Lpresto_types$AccountId$ as $m_Lpresto_types$AccountId$ };
//# sourceMappingURL=presto.types$-Account-Id$.js.map
